import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Flame, MapPin, Printer } from "lucide-react";

const PRODUCTION_URL = "https://smokey-af-bbq.emergent.host";

const MENU = [
  { name: "Smokey AF BBQ Pizza", desc: "Chipotle base, pulled pork, bacon", price: "$16" },
  { name: "Nacho Pork Pizza", desc: "Nacho cheese base, jalapeños", price: "$16" },
  { name: "Pepperoni Pizza", desc: "Classic red sauce, crispy pepperoni", price: "$16", isNew: true },
  { name: "Chicken Alfredo Pizza", desc: "Alfredo, grilled chicken, Parm", price: "$16", isNew: true },
  { name: "Chicken Bacon Ranch Pizza", desc: "Ranch base, chicken, bacon", price: "$16", isNew: true },
  { name: "BBQ Boat", desc: "Steak rolls, pulled pork, slaw", price: "$14" },
  { name: "Bavarian Behemoth Pretzel", desc: "Oversized, BBQ butter, beer-cheese dip", price: "$12", isNew: true },
  { name: "Pulled Pork Sandwich", desc: "Toasted brioche, slaw, fries", price: "$14" },
  { name: "Japanese BBQ Burger", desc: '1¼" smoked patty, mayo, fries', price: "$14" },
  { name: "Loaded Pork Fries", desc: "Cubed fries, cheese sauce, pork", price: "$14" },
  { name: "Garlic Parmesan Wings (6)", desc: "Bone-in, garlic butter, Parm", price: "$12", isNew: true },
  { name: "BBQ Wings (6)", desc: "Bone-in, house BBQ, sesame", price: "$12", isNew: true },
  { name: "Buffalo Wings (6)", desc: "Bone-in, fiery, ranch & celery", price: "$12", isNew: true },
  { name: "Chipotle Firecracker Wings (6)", desc: "Bone-in, smoky chipotle-garlic heat", price: "$12", isNew: true },
  { name: "BBQ Chicken Sandwich", desc: "Grilled chicken, BBQ, mayo, LT", price: "$10", isNew: true },
  { name: "Pork Crack Mash Bowl", desc: "Cream cheese mash, buffalo, bacon", price: "$10" },
  { name: "Nacho Jalapeño Pork Sandwich", desc: "Nacho cheese, jalapeños, no slaw", price: "$10" },
  { name: "Japanese Pork Sandwich", desc: "Japanese BBQ sauce, slaw", price: "$10" },
  { name: "BBQ Sushi", desc: "Pulled pork, purple peppers, sauce", price: "$8" },
  { name: "Mini Pulled Pork Sandwich", desc: "Slider, pork, slaw, BBQ", price: "$7" },
  { name: "Mini BBQ Boat", desc: "Single bun, pulled pork, slaw", price: "$7" },
  { name: "Order of Fries", desc: "Straight-cut, extra crispy, sea salt", price: "$5", isNew: true },
];

export default function Flyer() {
  return (
    <div className="min-h-screen bg-zinc-800 flyer-root">
      {/* Print button — hidden on print */}
      <div className="no-print fixed top-4 left-1/2 -translate-x-1/2 z-50 flex gap-2">
        <button
          onClick={() => window.print()}
          data-testid="flyer-print-btn"
          className="inline-flex items-center gap-2 bg-[#FF3B30] hover:bg-white hover:text-black text-white font-['Anton'] tracking-widest uppercase px-5 py-3 text-xs transition-colors shadow-2xl"
        >
          <Printer className="w-4 h-4" />
          Print Flyer
        </button>
        <a
          href="/smokey-af-flyer.png"
          download
          className="inline-flex items-center bg-black/60 backdrop-blur border border-white/20 hover:border-white text-white font-['Anton'] tracking-widest uppercase px-5 py-3 text-xs transition-colors"
        >
          Download PNG
        </a>
      </div>

      <div className="flex justify-center py-10 px-4">
        <div
          data-testid="flyer-sheet"
          className="flyer-sheet relative w-full max-w-[850px] aspect-[8.5/11] bg-black overflow-hidden border border-white/10"
          style={{
            backgroundImage:
              "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255,59,48,0.18), transparent 60%), radial-gradient(ellipse 60% 40% at 50% 100%, rgba(255,140,0,0.15), transparent 60%)",
          }}
        >
          {/* Grain overlay */}
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none opacity-30 mix-blend-screen"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* TOP - Brand & hook */}
          <div className="relative px-10 pt-10">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <Flame
                  className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.6)]"
                  style={{ width: 22, height: 22 }}
                />
                <span
                  className="font-['Anton'] uppercase text-white tracking-[0.3em]"
                  style={{ fontSize: 16 }}
                >
                  Smokey <span className="text-[#FF3B30]">AF</span> Barbecue
                </span>
              </div>
              <span
                className="font-['Anton'] uppercase bg-[#FF3B30] text-white px-3 py-1.5 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.5)]"
                style={{ fontSize: 14 }}
              >
                Now Open
              </span>
            </div>

            <div className="flex items-center gap-3 mb-3">
              <MapPin className="w-4 h-4 text-[#FF8C00]" />
              <span
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.4em]"
                style={{ fontSize: 11 }}
              >
                City of Fremont, Nebraska
              </span>
            </div>

            <h1
              className="font-['Anton'] uppercase text-white leading-[0.85]"
              style={{ fontSize: 64, letterSpacing: "-0.02em" }}
            >
              Real BBQ.
              <br />
              <span style={{ color: "#FF3B30" }}>Right Here.</span>
            </h1>
            <p
              className="mt-2 font-['Outfit'] italic text-zinc-300"
              style={{ fontSize: 15 }}
            >
              Hand-pulled. Wood-fired. Honest as hell.
            </p>
          </div>

          {/* Hero food strip — three photos */}
          <div className="relative grid grid-cols-3 gap-1 mt-5 mb-5 px-10">
            <div
              className="bg-cover bg-center border border-white/10"
              style={{ backgroundImage: "url(/menu/nacho_pork_pizza.png)", height: 150 }}
            />
            <div
              className="bg-cover bg-center border border-white/10"
              style={{ backgroundImage: "url(/menu/bbq_boat_hero.png)", height: 150 }}
            />
            <div
              className="bg-cover bg-center border border-white/10"
              style={{ backgroundImage: "url(/menu/pork_crack_mash_bowl.png)", height: 150 }}
            />
          </div>

          {/* MENU - two columns */}
          <div className="relative px-10">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#FF3B30]" />
              <h2
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.4em]"
                style={{ fontSize: 12 }}
              >
                The Menu · Nineteen Plates
              </h2>
            </div>

            <div className="grid grid-cols-2 gap-x-7 gap-y-1">
              {MENU.map((item) => (
                <div
                  key={item.name}
                  className="flex items-baseline justify-between gap-3 border-b border-white/10 pb-0.5"
                >
                  <div className="min-w-0">
                    <div
                      className="font-['Anton'] uppercase text-white tracking-wider leading-tight truncate"
                      style={{ fontSize: 11 }}
                    >
                      {item.name}
                      {item.isNew && (
                        <span
                          className="ml-1.5 align-middle bg-[#FF3B30] text-white px-1"
                          style={{ fontSize: 7 }}
                        >
                          NEW
                        </span>
                      )}
                    </div>
                    <div
                      className="font-['Outfit'] text-zinc-400 italic truncate leading-tight"
                      style={{ fontSize: 9 }}
                    >
                      {item.desc}
                    </div>
                  </div>
                  <div
                    className="font-['Anton'] text-[#FF8C00] flex-shrink-0"
                    style={{ fontSize: 14 }}
                  >
                    {item.price}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* BOTTOM - QR + address */}
          <div className="absolute bottom-0 left-0 right-0 px-10 pb-8">
            <div
              className="absolute inset-x-0 bottom-0 h-32 -z-0"
              style={{
                background:
                  "linear-gradient(to top, #000 0%, rgba(0,0,0,0.85) 50%, transparent 100%)",
              }}
            />
            <div className="relative flex items-end justify-between gap-6">
              {/* QR */}
              <div className="flex items-end gap-4">
                <div className="bg-white p-2.5 shadow-[0_15px_40px_-10px_rgba(255,59,48,0.4)]">
                  <QRCodeSVG
                    value={PRODUCTION_URL}
                    size={110}
                    level="H"
                    bgColor="#ffffff"
                    fgColor="#000000"
                    includeMargin={false}
                  />
                </div>
                <div className="pb-2">
                  <div
                    className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.4em]"
                    style={{ fontSize: 10 }}
                  >
                    Scan to Order
                  </div>
                  <div
                    className="font-['Anton'] uppercase text-white tracking-wider leading-tight mt-1"
                    style={{ fontSize: 20 }}
                  >
                    Card or Cash
                  </div>
                  <div
                    className="font-['Outfit'] text-zinc-400 mt-1"
                    style={{ fontSize: 10 }}
                  >
                    Order ahead. Pickup or eat in.
                  </div>
                </div>
              </div>

              {/* Address */}
              <div className="text-right">
                <div
                  className="font-['Outfit'] uppercase text-zinc-500 tracking-[0.3em]"
                  style={{ fontSize: 9 }}
                >
                  Find Us Inside
                </div>
                <div
                  className="font-['Anton'] uppercase text-white tracking-wider leading-tight mt-1"
                  style={{ fontSize: 22 }}
                >
                  Southern Style Bar
                </div>
                <div
                  className="font-['Outfit'] text-zinc-300 mt-1"
                  style={{ fontSize: 13 }}
                >
                  648 N Broad St
                  <br />
                  Fremont, NE 68025
                </div>
                <div
                  className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.3em] mt-2"
                  style={{ fontSize: 9 }}
                >
                  smokey-af-bbq.emergent.host
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print styles */}
      <style>{`
        @media print {
          @page { size: letter; margin: 0; }
          html, body {
            background: #000 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .no-print { display: none !important; }
          .flyer-root { background: #000 !important; min-height: 0 !important; }
          .flyer-root > div { padding: 0 !important; }
          .flyer-sheet {
            width: 100% !important;
            max-width: none !important;
            height: 100vh !important;
            aspect-ratio: auto !important;
            border: none !important;
            page-break-inside: avoid;
          }
        }
      `}</style>
    </div>
  );
}
